import React from "react";
import PhoneInput from "./PhoneInput";

const SpouseNextOfKinStep = ({
  spouse,
  spouseNextOfKin,
  nextOfKin,
  maritalStatus,
  onSpouseChange,
  onSpouseEmploymentChange,
  onSpouseNextOfKinChange,
  onNextOfKinChange,
}) => {
  return (
    <>
      {maritalStatus === "Married" && (
        <>
      <h5 className="mb-3">Spouse Information</h5>
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Spouse First Name</label>
          <input
            type="text"
            className="form-control"
            value={spouse.firstName}
            onChange={(e) => onSpouseChange("firstName", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Spouse Last Name</label>
          <input
            type="text"
            className="form-control"
            value={spouse.lastName}
            onChange={(e) => onSpouseChange("lastName", e.target.value)}
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Date of Birth</label>
          <input
            type="date"
            className="form-control"
            value={spouse.dateOfBirth}
            onChange={(e) => onSpouseChange("dateOfBirth", e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <label className="form-label">Age</label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={spouse.age}
            onChange={(e) => onSpouseChange("age", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Address</label>
          <input
            type="text"
            className="form-control"
            value={spouse.address}
            onChange={(e) => onSpouseChange("address", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={spouse.email}
            onChange={(e) => onSpouseChange("email", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Mobile Phone</label>
          <PhoneInput
            value={spouse.phoneMobile}
            onChange={(val) => onSpouseChange("phoneMobile", val)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Occupation</label>
          <input
            type="text"
            className="form-control"
            value={spouse.occupation}
            onChange={(e) => onSpouseChange("occupation", e.target.value)}
          />
        </div>
      </div>

      <div className="row g-3 mt-3">
        <div className="col-md-6">
          <label className="form-label">Spouse Employer</label>
          <input
            type="text"
            className="form-control"
            value={spouse.employment.employer}
            onChange={(e) => onSpouseEmploymentChange("employer", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Employer Address</label>
          <input
            type="text"
            className="form-control"
            value={spouse.employment.employerAddress}
            onChange={(e) =>
              onSpouseEmploymentChange("employerAddress", e.target.value)
            }
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Monthly Income (TTD)</label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={spouse.employment.monthlyIncome}
            onChange={(e) =>
              onSpouseEmploymentChange("monthlyIncome", e.target.value)
            }
          />
        </div>
        <div className="col-md-4">
          <label className="form-label">Work Phone</label>
          <PhoneInput
            value={spouse.employment.workPhone}
            onChange={(val) => onSpouseEmploymentChange("workPhone", val)}
          />
        </div>
      </div>
        </>
      )}

      {maritalStatus === "Married" && (
        <>
          <hr className="my-4" />
          <h5 className="mb-3">Spouse&apos;s Next of Kin</h5>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                value={spouseNextOfKin.name}
                onChange={(e) => onSpouseNextOfKinChange("name", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Relationship</label>
              <input
                type="text"
                className="form-control"
                value={spouseNextOfKin.relationship}
                onChange={(e) => onSpouseNextOfKinChange("relationship", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={spouseNextOfKin.address}
                onChange={(e) => onSpouseNextOfKinChange("address", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <PhoneInput
                value={spouseNextOfKin.phone}
                onChange={(val) => onSpouseNextOfKinChange("phone", val)}
              />
            </div>
          </div>
        </>
      )}

      <hr className="my-4" />

      <h5 className="mb-3">Next of Kin</h5>
      <div className="row g-3">
        <div className="col-md-6">
          <label className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            value={nextOfKin.name}
            onChange={(e) => onNextOfKinChange("name", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Relationship</label>
          <input
            type="text"
            className="form-control"
            value={nextOfKin.relationship}
            onChange={(e) => onNextOfKinChange("relationship", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Address</label>
          <input
            type="text"
            className="form-control"
            value={nextOfKin.address}
            onChange={(e) => onNextOfKinChange("address", e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Phone</label>
          <PhoneInput
            value={nextOfKin.phone}
            onChange={(val) => onNextOfKinChange("phone", val)}
          />
        </div>
      </div>
    </>
  );
};

export default SpouseNextOfKinStep;


